import { Stack, Typography } from "@mui/material";
import { useContext, useState } from "react";
import { RHFTextField } from "src/components/hook-form";

import Context from "../../context";
import { CustomizeFormValues } from "../../hooks/customizeFormUtils";
import ColorPicker from "./ColorPicker";
import InputAdornment from "./InputAdornment";

type Props = {
	title: string;
	name: keyof CustomizeFormValues;
};

export default function ColorSelector({ title, name }: Props) {
	const [showPicker, setShowPicker] = useState(false);

	const { values } = useContext(Context);

	return (
		<Stack flexDirection={"row"} alignItems={"center"} justifyContent='space-between'>
			<Typography variant='body1' fontSize={14} color='text.secondary'>
				{title}
			</Typography>
			<RHFTextField
				name={name}
				size='small'
				sx={{ width: 115 }}
				InputProps={{
					startAdornment: (
						<InputAdornment onClick={() => setShowPicker(true)} color={values[name] as string} />
					)
				}}
			/>
			{showPicker && <ColorPicker onClose={() => setShowPicker(false)} name={name} />}
		</Stack>
	);
}
